import { render, staticRenderFns } from "./Redes.vue?vue&type=template&id=24d6f449&scoped=true&"
import script from "./Redes.vue?vue&type=script&lang=js&"
export * from "./Redes.vue?vue&type=script&lang=js&"
import style0 from "./Redes.vue?vue&type=style&index=0&id=24d6f449&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6f449",
  null
  
)

export default component.exports